/* eslint-disable no-useless-catch */
import api, { endpoints } from '@utils/api';


export const sendOtp = async (mobile_number) => {
  try {
    const response = await api.post(endpoints.sendOtp, { mobile_number });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const verifyOtp = async (mobile_number, otp) => {
  try {
    const response = await api.post(endpoints.verifyOtp, { mobile_number, otp });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const resendOtp = async (mobile_number) => {
  try {
    const response = await api.post(endpoints.resendOtp, { mobile_number });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getCurrentUser = async () => {
  try {
    const response = await api.get(endpoints.getCurrentUser);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const selectCompany = async ({ userId, companyId }) => {
  const response = await api.post(endpoints.selectCompany, {
    userId,
    companyId,
  });

  return response.data;
};

